export default __webpack_public_path__ + "static/media/monalisa.c723176b.jpg";